import { i18nMark } from 'lingui-react';

const formattedMessages = {
  title: i18nMark('What\'s the complaint?'),
  subtitle: i18nMark('You can select a complaint code or enter a description. When possible, fill in both. That helps the service provider expedite your case.'),
  complaintCode: i18nMark('Complaint Code'),
  description: i18nMark('Description'),
  continueButton: i18nMark('Continue'),
  charactersLeft: i18nMark('{value} {value, plural, one {Character} other {Characters}} left'),
  characterCountWarning: i18nMark('You reached the max character count.'),
};

export default formattedMessages;



// WEBPACK FOOTER //
// ./compositions/ReasonForRepairStep/messages.js